// localStorage wrappers. Theme is handled by next-themes with the
// 'n3o-work-theme' storage key; only the remaining UI prefs live here.

const LAST_VIEW_KEY = 'n3o-work-last-view'
const SIDEBAR_KEY = 'n3o-work-sidebar'

function read(key: string): string | null {
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

function write(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value)
  } catch {
    // Private mode / quota — UI prefs are best-effort.
  }
}

export function getLastView(): string | null {
  return read(LAST_VIEW_KEY)
}

export function setLastView(path: string): void {
  write(LAST_VIEW_KEY, path)
}

export function getSidebarOpen(): boolean {
  return read(SIDEBAR_KEY) !== 'collapsed'
}

export function setSidebarOpen(open: boolean): void {
  write(SIDEBAR_KEY, open ? 'expanded' : 'collapsed')
}
